import AddIcon from "@mui/icons-material/Add";
import TuneIcon from "@mui/icons-material/Tune";
import { Grid, Toolbar, Typography } from "@mui/material";
import { uniq } from "lodash";
import moment from "moment";
import { useEffect, useMemo, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomTextField from "../../../../components/CustomTextField";
import Select from "../../../../components/Select/Select";
import {
  getMedicalHistoryByPetId,
  getMedicalHistoryByPetIdWoLoader,
} from "../../../../redux/reducers/medicalHistorySlice";
import { getCompliantSummaryByIdWoLoader } from "../../../../redux/reducers/petSlice";
import { getClinicVets } from "../../../../redux/reducers/vetSlice";
import { AppColors } from "../../../../util/AppColors";
import { a4PrintConfig } from "../../../../util/commonConfig";
import { serviceTypes, workbookStatusList } from "../../../../util/dropList";
import { genderEnum } from "../../../../util/enum";
import { getKey, getRightSaluation } from "../../../../util/function";
import ComponentToPrint from "../../../CommonScreens/ContentToPrint/ContentToPrint";
import BodyMapView from "../../../CommonScreens/WorkBook/BodyMapView";
import DiagnosticsView from "../../../CommonScreens/WorkBook/DiagnosticsView";
import FileView from "../../../CommonScreens/WorkBook/FileView";
import FormsView from "../../../CommonScreens/WorkBook/FormsView";
import PrescriptionView from "../../../CommonScreens/WorkBook/PrescriptionView";
import PreventiveView from "../../../CommonScreens/WorkBook/PreventiveView";
import ProceduresView from "../../../CommonScreens/WorkBook/ProceduresView";
import SoapNoteView from "../../../CommonScreens/WorkBook/SoapNoteView";
import TreatmentPlanView from "../../../CommonScreens/WorkBook/TreatmentPlanView";
import VitalsView from "../../../CommonScreens/WorkBook/VitalsView";

const arrow = { width: 30, height: 30, color: AppColors.appPrimary };
const initSearch = {
  // startDate: null,
  // endDate: null,
  serviceTypes: [],
  vetNames: [],
  caseIds: [],
  reasons: [],
  // tags: [],
};
const initFilter = {
  visible: false,
  added: false,
  selectedList: [],
  values: {},
};
const filterByList = ["Condition Status", "Condition", "Date"];
const dropFields = ["Condition Status", "Condition"];

const MedicalHistoryNew = ({ petId }) => {
  const dispatch = useDispatch();
  const printRef = useRef(null);
  const listInnerRef = useRef();
  const hasReachedBottomRef = useRef(false);
  const [summaryModVsble, setSummaryModVsble] = useState(false);
  const [activeTab, setActiveTab] = useState("Problem");
  const [searchValue, setSearchValue] = useState("");
  const [samData, setSamData] = useState([]);
  const [heights, setHeights] = useState([]);
  const [page, setPage] = useState(1);
  const [medicalHistoryList, setMedicalHistoryList] = useState([]);
  const [searchValues, setSearchValues] = useState(initSearch);
  const [filterValues, setFilterValues] = useState(initFilter);
  const { petMedicalHistoryAll } = useSelector(
    (state) => state?.medicalHistory,
  );
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  // const petDet = useSelector(
  //   (state) => state?.pet?.complaintSummary?.data?.pet,
  // );
  const { clinicStocks } = useSelector((state) => state?.clinic);
  const lastSummary = useSelector((state) => state?.pet?.lastSummary?.data);
  const itemsPerLoad = 10;
  const mandateDataRaw = sessionStorage.getItem("mandateData");
  const { clinic: clinicDet } = useMemo(() => {
    if (!mandateDataRaw) {
      return { clinic: {} };
    }
    try {
      const reqData = JSON.parse(mandateDataRaw);
      return { clinic: reqData?.clinic ?? {} };
    } catch {
      return { clinic: {} };
    }
  }, [mandateDataRaw]);

  useEffect(() => {
    if (petId) {
      dispatch(
        getMedicalHistoryByPetIdWoLoader({
          petId,
          data: {
            type: "all",
            appointmentStatus: ["completed", , "finalize"],
            page: 1,
            itemSize: 50,
          },
        }),
      );
    }
    dispatch(getClinicVets("?type=all"));
    // dispatch(getClinicStocksWoLoader());
  }, []);

  useEffect(() => {
    onApiCall(1);
  }, [
    searchValues?.startDate,
    searchValues?.endDate,
    searchValues?.serviceTypes,
    searchValues?.vetNames,
    searchValues?.caseIds,
    searchValues?.reasons,
    searchValues?.tags,
  ]);

  const onSearchChange = (e) => {
    const { name, value } = e?.target;
    setSearchValues({
      ...searchValues,
      [name?.trim()?.replace(/,$/, "")]: value, // remove spaces & trailing commas
    });
  };

  const getFilterObj = (currentPage = 1, reset = false) => {
    setPage(currentPage);
    const data = {
      type: "all",
      appointmentStatus: ["finalize", "completed"],
      itemSize: itemsPerLoad,
      page: currentPage,
    };
    if (reset) return data;
    if (searchValues?.serviceTypes?.length > 0) {
      data.serviceTypes = searchValues?.serviceTypes?.map((li) => li?.value);
    }
    if (searchValues?.vetNames?.length > 0) {
      data.vetNames = searchValues?.vetNames?.map((li) => li?.apiValue);
    }
    if (searchValues?.caseIds?.length > 0) {
      data.caseIds = searchValues?.caseIds?.map((li) => li?.value);
    }
    if (searchValues?.reasons?.length > 0) {
      data.reasons = searchValues?.reasons?.map((li) => li?.value);
    }

    if (
      filterValues?.selectedList?.includes("Condition") &&
      filterValues?.values?.["Condition"]
    ) {
      data.tag = (filterValues?.values?.["Condition"] ?? [])?.map(
        (li) => li?.value,
      );
    }
    if (
      filterValues?.selectedList?.includes("Condition Status") &&
      filterValues?.values?.["Condition Status"]
    ) {
      data.caseStatus = (filterValues?.values?.["Condition Status"] ?? [])?.map(
        (li) => li?.value,
      );
    }
    if (filterValues?.selectedList?.includes("Date")) {
      if (filterValues?.values?.["Start Date"]) {
        data.startDate = moment(
          new Date(filterValues?.values?.["Start Date"]),
        ).format("YYYY-MM-DD");
      }
      if (
        filterValues?.values?.["End Date"] ||
        filterValues?.values?.["Start Date"]
      ) {
        data.endDate = moment(
          new Date(
            filterValues?.values?.["End Date"] ??
              filterValues?.values?.["Start Date"],
          ),
        ).format("YYYY-MM-DD");
      }
    }
    return data;
  };

  const onApiCall = (currPage = 1, reset = false) => {
    dispatch(
      getMedicalHistoryByPetId({ petId, data: getFilterObj(currPage, reset) }),
    ).then((res) => {
      if (res?.payload) {
        setMedicalHistoryList([
          ...(currPage === 1 || reset ? [] : (medicalHistoryList ?? [])),
          ...(res?.payload?.data ?? []),
        ]);
      }
    });
  };

  const handleOpen = (name, i, value) => {
    const reqData = samData?.map((dta, ind) => {
      if (i === ind) {
        return { ...dta, [name]: { ...dta[name], open: value } };
      }
      return dta;
    });
    setSamData(reqData);
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId,
    );
    return reqStock?.stockBatch ?? [];
  };

  const onScroll = () => {
    if (listInnerRef?.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef?.current;
      const threshold = 10; // Allow 10px threshold for floating point precision
      const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
      const isAtBottom = distanceFromBottom <= threshold;

      if (isAtBottom && !hasReachedBottomRef.current) {
        // console.log("Reached bottom", { scrollTop, scrollHeight, clientHeight, distanceFromBottom });
        hasReachedBottomRef.current = true;
        onApiCall(page + 1);
        // This will be triggered after hitting the last element.
        // API call should be made here while implementing pagination.
      } else if (!isAtBottom && hasReachedBottomRef.current) {
        // Reset flag when scrolling back up
        hasReachedBottomRef.current = false;
      }
    }
  };

  const getVetList = () => {
    const historyVets = (petMedicalHistoryAll?.data ?? [])?.map(
      (li) => li?.doctorId,
    );
    const uniqVetList = uniq(historyVets ?? []);
    const reqVetList =
      (clinicVets ?? [])
        ?.filter(
          (vl) => vl?.status === "Y" && uniqVetList?.includes(vl?.doctorId),
        )
        ?.map((vet) => {
          return {
            name: `${getRightSaluation(clinicVets, vet?.doctorId)}${vet?.name}`,
            value: vet?.doctorId,
            id: vet?.doctorId,
            apiValue: vet?.name ?? "",
          };
        }) ?? [];
    return reqVetList;
  };

  const getCaseIds = () => {
    const reqList = (petMedicalHistoryAll?.data ?? [])?.map((li) => ({
      name: li?.caseId?.toString(),
      value: li?.caseId?.toString(),
    }));
    return reqList;
  };

  const getSystemList = () => {
    const reqList = (petMedicalHistoryAll?.data ?? [])
      ?.flatMap((app) => {
        const notes = app?.clinicalNotes || [];
        // If clinicalNotes exist → extract category from tag
        // if (notes?.length > 0) {
        //   return notes?.flatMap((note) => {
        //     const tag = note?.tag;
        //     if (!tag || !tag?.includes("-")) return [];
        //     return [tag?.substring(0, tag?.indexOf("-"))?.trim()];
        //   });
        // }
        // Else → fallback to reason array
        return app?.reason || [];
      })
      ?.filter(Boolean);
    return uniq(reqList ?? [])?.map((li) => ({ name: li, value: li }));
  };

  const getConditionList = () => {
    const reqList = (petMedicalHistoryAll?.data ?? [])
      ?.flatMap((app) => app?.clinicalNotes || [])
      ?.flatMap((note) => {
        return note?.tag;
        // const tag = note?.tag;
        // if (!tag || !tag?.includes("-")) return [];
        // return [tag?.substring(tag?.indexOf("-") + 1)?.trim()];
      })
      ?.filter(Boolean);
    return uniq(reqList ?? [])?.map((li) => ({
      name: li?.substring(li?.indexOf("-") + 1)?.trim(),
      value: li,
    }));
  };

  const handleReset = () => {
    flushSync(() => {
      setSearchValues(initSearch);
    });
    flushSync(() => {
      setFilterValues({
        ...initFilter,
        selectedList: [],
        values: {},
      });
    });
    onApiCall(1, true);
  };

  const onFilterChange = (name, value) => {
    const reqObj = { ...filterValues, [name]: value };
    setFilterValues(reqObj);
  };

  const onCloseFilter = () => {
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const onFilterValuesChange = (e) => {
    const { name, value } = e?.target;
    const reqObj = {
      ...filterValues,
      values: {
        ...filterValues?.values,
        [name?.trim()?.replace(/,$/, "")]: value,
      },
    };
    setFilterValues(reqObj);
  };

  const onFilterReset = () => {
    const reqObj = {
      ...initFilter,
      visible: true,
      selectedList: [],
      values: {},
    };
    setFilterValues(reqObj);
  };

  const onSelectFilter = (name) => {
    const reqObj = { ...filterValues };
    let reqList = filterValues?.selectedList;
    if (reqList?.includes(name)) {
      reqList = reqList?.filter((item) => item !== name);
    } else {
      reqList.push(name);
    }
    reqObj.selectedList = reqList;
    setFilterValues(reqObj);
  };

  const onFilterAdd = (value) => {
    const reqObj = { ...filterValues, added: value };
    setFilterValues(reqObj);
  };

  const onApplyFilter = () => {
    onApiCall();
    const reqObj = { ...filterValues, visible: false };
    setFilterValues(reqObj);
  };

  const handleViewSmmary = (apntId = null) => {
    if (!apntId) return;
    dispatch(getCompliantSummaryByIdWoLoader(apntId));
    setSummaryModVsble(true);
  };

  const handlePrint = useReactToPrint({
    content: () => printRef?.current,
    documentTitle: `${lastSummary?.appointment?.petName ?? ""}_${Date.now()}`,
    removeAfterPrint: true,
    pageStyle: a4PrintConfig,
  });

  return (
    <>
      <div
        className="scroll-80vh w100Per"
        onScroll={onScroll}
        ref={listInnerRef}
      >
        <Grid container className="back-white">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className="ph20">
            <Toolbar variant="regular">
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row-ali-cen mt10 mh20Min flex-space-btwn">
                  <div className="w18Per">
                    <Select
                      list={serviceTypes}
                      value={searchValues?.serviceTypes ?? []}
                      name="serviceTypes"
                      handleChange={onSearchChange}
                      label="Service Type"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div className="w18Per">
                    <Select
                      list={getVetList()}
                      value={searchValues?.vetNames ?? []}
                      name="vetNames"
                      handleChange={onSearchChange}
                      label="Vet Name"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div className="w18Per">
                    <Select
                      list={getCaseIds()}
                      value={searchValues?.caseIds ?? []}
                      name="caseIds"
                      handleChange={onSearchChange}
                      label="Case ID"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div className="w18Per">
                    <Select
                      list={getSystemList()}
                      value={searchValues?.reasons ?? []}
                      name="reasons"
                      handleChange={onSearchChange}
                      label="System"
                      backgroundColor={AppColors.lightBlue2}
                      multiSelectSearchCheck
                    />
                  </div>
                  <div
                    className="flex-row-ali-cen filter cursor"
                    onClick={() => onFilterChange("visible", true)}
                  >
                    <TuneIcon sx={{ color: AppColors.appPrimary }} />
                    <Typography className="font-medium fs12 blue-color ml10">
                      {filterValues?.selectedList?.length > 0
                        ? `${filterValues?.selectedList?.length} `
                        : ""}
                      Filter
                    </Typography>
                  </div>
                  <div>
                    <div>
                      <CustomButton
                        text="Reset"
                        smallBtn
                        redBtn
                        onClick={handleReset}
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Toolbar>
            <div>
              {activeTab === "Problem" ? (
                // medicalHistory?.data
                medicalHistoryList?.length > 0 ? (
                  medicalHistoryList?.map((li, i) => {
                    return (
                      <div
                        className="w100Per getHeight"
                        key={getKey()}
                        // style={i !== 0 ? { marginTop: -40 } : { marginTop: 10 }}
                      >
                        <div className="flex-row mt20">
                          <div className="flex-column">
                            <div className="flex-center h50">
                              <div className="gry-dot" />
                            </div>
                            <div
                              style={{
                                width: 1,
                                height: heights?.[i] - 0,
                                background: "#00000033",
                                marginLeft: 5,
                                marginTop: -20,
                              }}
                            />
                          </div>

                          <div
                            className={`w10Per  ${li?.isMaster ? "" : "ml40"}`}
                          >
                            <div className="flex-column flex-center">
                              <Typography className="blue-color txt-semi-bold fs30 mb10Min">
                                {moment(li?.date).format("DD")}
                              </Typography>
                              <Typography className="blue-color txt-semi-bold fs12">
                                {moment(li?.date).format("MMM YYYY")}
                              </Typography>

                              <div
                                className={`mt5 ${
                                  li?.isMaster
                                    ? "org-time-highlight"
                                    : "rse-time-highlight"
                                }`}
                              />
                            </div>
                          </div>
                          <div className="w80Per">
                            <div className="his-bodr">
                              <div className="flex-row">
                                <div className="flex-row-ali-cen p10">
                                  <div>
                                    <div className="flex-row-ali-cen">
                                      <Typography className="font-bold fs14 blue-color">
                                        Case ID - {li?.caseId}
                                      </Typography>
                                      <Typography className="light-blue fs14 txt-semi-bold ml10">
                                        {li?.serviceType}
                                        {li?.serviceType === "Consultation"
                                          ? ` | ${
                                              Array.isArray(li?.reason)
                                                ? li?.reason?.join(", ")
                                                : ""
                                            }`
                                          : ""}
                                      </Typography>
                                      {/* {li?.tags?.map((tg, i) => (
                                      <Typography
                                        className="fs12 font-medium black19 ml10 gry-tag"
                                        key={tg + i}
                                      >
                                        {tg}
                                      </Typography>
                                    ))} */}
                                    </div>
                                    <div className="flex-row-ali-cen mt10">
                                      <img
                                        src={require("../../../../assets/images/png/calen.png")}
                                        className="img-wh15"
                                      />
                                      <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                        {moment(
                                          new Date(li?.appointmentTime),
                                        ).format("DD MMM YYYY")}
                                      </Typography>
                                      <img
                                        src={require("../../../../assets/images/png/clock.png")}
                                        className="img-wh15 ml10"
                                      />
                                      <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                        {moment(
                                          new Date(li?.appointmentTime),
                                        ).format("HH:mm")}
                                      </Typography>
                                      <img
                                        src={require("../../../../assets/images/png/steath.png")}
                                        className="img-wh15 ml10"
                                      />
                                      <Typography className="yellow2 fs12 txt-semi-bold ml5">
                                        {getRightSaluation(
                                          clinicVets,
                                          li?.doctorId,
                                        )}
                                        {/* {li?.doctorId === li?.clinicId
                                        ? ""
                                        : "Dr. "} */}
                                        {li?.doctorName}
                                      </Typography>
                                    </div>
                                  </div>
                                  <div className="flex1-end">
                                    <div className="flex-column">
                                      {/* <div className="flex-end">
                                    <Typography
                                      className={`fs12 font-bold white-color ${
                                        li?.status === "Under Treatment" ||
                                        li?.status === "Monitoring"
                                          ? "yellow-tag"
                                          : li?.status === "Inactive"
                                          ? "org-tag"
                                          : li?.status === "Resolved"
                                          ? "grn-tag"
                                          : "red-tag"
                                      }`}
                                    >
                                      {li?.status}
                                    </Typography>
                                  </div> */}
                                      {/* <div className="flex-row-ali-cen mt10">
                                    <Typography className="gray21 fs12 font-medium">
                                      Connections:
                                    </Typography>
                                    <Typography
                                      className={`fs12 font-medium ml5 ${
                                        li?.isMaster ? "rose" : "orange5"
                                      }`}
                                    >
                                      {li?.connections?.length}{" "}
                                      {li?.isMaster ? "Child" : "Master"}
                                    </Typography>
                                  </div> */}
                                    </div>
                                  </div>
                                </div>
                                {li?.caseStatus?.length > 0 ? (
                                  <div className="flex1-end p10">
                                    <Typography
                                      className={`fs12 white-color br10 ph10 pv2 ${(li?.caseStatus ?? "")?.toLowerCase() === "acute" ? "blue-back" : (li?.caseStatus ?? "")?.toLowerCase() === "ongoing" ? "org-back3" : (li?.caseStatus ?? "")?.toLowerCase() === "chronic" ? "purple-back" : "green-back6"}`}
                                    >
                                      {li?.caseStatus}
                                    </Typography>
                                  </div>
                                ) : null}
                              </div>
                              <div className="ph5">
                                <div className="gry-hor-split mt5" />
                              </div>
                              <div className="p10">
                                <div key={getKey()}>
                                  {li?.procedures?.filter(
                                    (prd) =>
                                      prd?.appointmentId === li?.appointmentId,
                                  )?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "procedures",
                                            i,
                                            !li?.procedures?.open,
                                          );
                                        }}
                                      >
                                        <Typography className="font-bold fs14 blue-color">
                                          Procedures
                                        </Typography>
                                      </div>
                                      <ProceduresView
                                        procedures={li?.procedures?.filter(
                                          (prd) =>
                                            prd?.appointmentId ===
                                            li?.appointmentId,
                                        )}
                                      />
                                    </>
                                  ) : null}
                                  {li?.procedures
                                    ?.filter(
                                      (prd) =>
                                        prd?.appointmentId ===
                                        li?.appointmentId,
                                    )
                                    ?.flatMap(
                                      (proc) => proc?.procedureDetails || [],
                                    )
                                    ?.filter(
                                      (det) =>
                                        det?.type === "Administered" &&
                                        det?.status === "true",
                                    )?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "administered",
                                            i,
                                            !li?.administered?.open,
                                          );
                                        }}
                                      >
                                        <Typography className="font-bold fs14 blue-color">
                                          Administered
                                        </Typography>
                                      </div>
                                      <ProceduresView
                                        procedures={li?.procedures?.filter(
                                          (prd) =>
                                            prd?.appointmentId ===
                                            li?.appointmentId,
                                        )}
                                        isAdminister
                                      />
                                    </>
                                  ) : null}
                                  {/* <Typography className="font-bold fs14 blue-color">
                                  Summary
                                </Typography>
                                <Typography className="txt-regular fs12 gray11 ph20">
                                  Test
                                </Typography> */}
                                  {li?.prevetive?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "preventives",
                                            i,
                                            !li?.preventives?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.preventives?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Preventive
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="mr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>

                                      <PreventiveView
                                        preventives={li?.prevetive}
                                      />
                                    </>
                                  ) : null}
                                  {li?.diagnostics?.filter(
                                    (diag) => diag?.dueDate === li?.date,
                                    // li?.status?.toLowerCase() === "completed"
                                  )?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "diagnostics",
                                            i,
                                            !li?.diagnostics?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.diagnostics?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Diagnostics
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>

                                      <DiagnosticsView
                                        diagnostics={li?.diagnostics?.filter(
                                          (diag) => diag?.dueDate === li?.date,
                                          // li?.status?.toLowerCase() ===
                                          // "completed"
                                        )}
                                        showFileAlso
                                        isFilePreview
                                      />
                                    </>
                                  ) : null}
                                  {li?.prescription?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "prescriptions",
                                            i,
                                            !li?.prescriptions?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.prescriptions?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Prescription
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="mr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <PrescriptionView
                                        prescriptions={li?.prescription}
                                      />
                                    </>
                                  ) : null}
                                  {(li?.clinicalNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      cn?.consolidated,
                                  ) ??
                                  li?.clinicalNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      !cn?.consolidated,
                                  )) ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Soap Notes
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <SoapNoteView
                                        apntId={li?.appointmentId}
                                        soapNote={
                                          li?.clinicalNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              cn?.consolidated,
                                          ) ??
                                          li?.clinicalNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              !cn?.consolidated,
                                          )
                                        }
                                      />
                                    </>
                                  ) : null}
                                  {(li?.inpatientNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      cn?.type === "surgery" &&
                                      cn?.consolidated,
                                  ) ??
                                  li?.inpatientNotes?.find(
                                    (cn) =>
                                      cn?.appointmentId === li?.appointmentId &&
                                      cn?.type === "surgery",
                                  )) ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Surgery Documentation
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <SoapNoteView
                                        apntId={li?.appointmentId}
                                        soapNote={
                                          li?.inpatientNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              cn?.type === "surgery" &&
                                              cn?.consolidated,
                                          ) ??
                                          li?.inpatientNotes?.find(
                                            (cn) =>
                                              cn?.appointmentId ===
                                                li?.appointmentId &&
                                              cn?.type === "surgery",
                                          )
                                        }
                                        isSurgery
                                      />
                                    </>
                                  ) : null}
                                  {li?.treatmentPlan?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Protocol Forms
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <TreatmentPlanView
                                        plans={li?.treatmentPlan}
                                      />
                                    </>
                                  ) : null}
                                  {li?.forms?.filter((frm) => frm?.status)
                                    ?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Consent Forms
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <FormsView
                                        forms={li?.forms?.filter(
                                          (frm) => frm?.status,
                                        )}
                                      />
                                    </>
                                  ) : null}
                                  {li?.vitals?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Vitals
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <VitalsView vitals={li?.vitals} />
                                    </>
                                  ) : null}
                                  {li?.bodyMaps?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Body Map
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <BodyMapView bodyMaps={li?.bodyMaps} />
                                    </>
                                  ) : null}
                                  {li?.files?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "others",
                                            i,
                                            !li?.others?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.others?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="font-bold fs14 blue-color">
                                          Files
                                        </Typography>
                                        {/* <div className="flex1-end">
                                    <div className="pr10">
                                      <CustomButton text="View" smallBtn />
                                    </div>
                                  </div> */}
                                      </div>
                                      <FileView files={li?.files} />
                                    </>
                                  ) : null}
                                  {li?.notes?.length > 0 ? (
                                    <>
                                      <div
                                        className="mt10 flex-row-ali-cen"
                                        onClick={() => {
                                          handleOpen(
                                            "notes",
                                            i,
                                            !li?.notes?.open,
                                          );
                                        }}
                                      >
                                        {/* {li?.notes?.open ? (
                                    <ArrowDropDownIcon sx={arrow} />
                                  ) : (
                                    <ArrowRightIcon sx={arrow} />
                                  )} */}
                                        <Typography className="fs14 blue-color font-bold">
                                          Notes
                                        </Typography>
                                      </div>
                                      <Typography
                                        className="fs12 txt-regular gray11"
                                        style={{
                                          whiteSpace: "pre-wrap",
                                          wordBreak: "break-word",
                                        }}
                                        component="div"
                                      >
                                        {(li?.notes ?? "")
                                          ?.split("\n")
                                          ?.map((line, index) => (
                                            <div key={index}>
                                              {line || "\u00A0"}
                                            </div>
                                          ))}
                                      </Typography>
                                      {/* <Typography className="fs12 txt-regular gray11">
                                        {li?.notes}
                                      </Typography> */}
                                    </>
                                  ) : null}
                                  <div className="flex1-end mt10">
                                    <div>
                                      <CustomButton
                                        text="Print"
                                        smallBtn
                                        onClick={() =>
                                          handleViewSmmary(li?.appointmentId)
                                        }
                                      />
                                    </div>
                                  </div>
                                  {/* <div
                                  className="mt10 flex-row-ali-cen"
                                  onClick={() => {
                                    handleOpen("others", i, !li?.others?.open);
                                  }}
                                >
                                  <Typography className="font-bold fs14 blue-color">
                                    Others
                                  </Typography>
                                </div>

                                {li?.others?.open ? (
                                  li?.others?.list?.length > 0 ? (
                                    li?.others?.list?.map((pre, i) => (
                                      <div
                                        className="mt5 mh10"
                                        key={i + "other"}
                                      >
                                        <div className="gray-back-con1">
                                          <div className="flex-row-wrap1">
                                            <Typography className="fs12 txt-semi-bold black">
                                              Product Name: Anobivac
                                            </Typography>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Vaccine:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                Hepatitis
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Manufacturer:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                Healthcare Plus
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Batch No:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                B2
                                              </Typography>
                                            </div>
                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Dose:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                1 mg
                                              </Typography>
                                            </div>

                                            <div className="flex-row-ali-cen ml10">
                                              <div className="gray-dot" />
                                              <Typography className="font-medium fs12 black ml5">
                                                Administered date & by:
                                              </Typography>
                                              <Typography className="txt-regular fs12 black ml5">
                                                12 - 06 - 2024 | Dr Rahul
                                              </Typography>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    ))
                                  ) : (
                                    <div className="no-rec">
                                      No records available
                                    </div>
                                  )
                                ) : null}

                                <div className="blue-box-brdr mt10">
                                  <Typography className="font-bold fs14 blue-color">
                                    Additional Notes
                                  </Typography>
                                  <Typography className="txt-regular fs12 gray11 ph20">
                                    {li?.additionalNotes}
                                  </Typography>
                                </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="no-rec h100">No records available</div>
                )
              ) : null}
            </div>
          </Grid>
        </Grid>
      </div>

      <CustomModal
        open={filterValues?.visible}
        onClose={onCloseFilter}
        header="Filter"
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography className="gray38 fs12 txt-regular">
                Filter by:
              </Typography>
              {!filterValues?.added ? (
                filterByList?.map((li, i) => (
                  <div className="flex-row-ali-cen" key={`${i}_li`}>
                    <div>
                      <CustomCheckbox
                        checked={filterValues?.selectedList?.includes(li)}
                        onChange={() => onSelectFilter(li)}
                      />
                    </div>
                    <Typography className="txt-regular fs14 black mb5 mlMin15">
                      {li}
                    </Typography>
                  </div>
                ))
              ) : (
                <div>
                  <div
                    className="flex-row-ali-cen gray-back4 ph10 pv10 br10 width-fit-con mt10 cursor"
                    onClick={() => onFilterAdd(false)}
                  >
                    <AddIcon
                      sx={{ color: AppColors.appPrimary, fontSize: 15 }}
                    />
                    <Typography className="font-medium fs12 blue-color ml5">
                      Add Filter
                    </Typography>
                  </div>
                  <div>
                    {filterValues?.selectedList?.map((li) => (
                      <div className="mt20">
                        {dropFields?.includes(li) ? (
                          <Select
                            list={
                              li === "Condition"
                                ? getConditionList()
                                : li === "Condition Status"
                                  ? workbookStatusList
                                  : []
                            }
                            value={filterValues?.values?.[li] ?? []}
                            name={li}
                            handleChange={onFilterValuesChange}
                            label={li}
                            multiSelectSearchCheck
                          />
                        ) : (
                          <div className="flex-row-between-align-center">
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="Start Date"
                                fullWidth
                                name="Start Date"
                                handleChange={onFilterValuesChange}
                                value={filterValues?.values?.["Start Date"]}
                                label="Start Date"
                                mobileDate
                              />
                            </div>
                            <div className="w45Per">
                              <CustomTextField
                                placeholder="End Date"
                                fullWidth
                                name="End Date"
                                handleChange={onFilterValuesChange}
                                value={filterValues?.values?.["End Date"]}
                                label="End Date"
                                mobileDate
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {!filterValues?.added ? (
                <div className="flex1-end mt15">
                  <div>
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => onFilterAdd(true)}
                    />
                  </div>
                </div>
              ) : (
                <div className="flex-row-center mt15">
                  <div>
                    <CustomButton
                      text="Reset All"
                      smallBtn
                      onClick={onFilterReset}
                      tabSelectdBtn
                    />
                  </div>
                  <div className="ml20">
                    <CustomButton
                      text="Apply Filters"
                      smallBtn
                      onClick={onApplyFilter}
                    />
                  </div>
                </div>
              )}
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={summaryModVsble}
        onClose={() => setSummaryModVsble(false)}
        header=""
        headerCenter
        headerBold
        modal
        modalWidth={80}
      >
        <div className="scroll-80vh">
          <ComponentToPrint
            ref={printRef}
            footer={
              clinicDet?.footer?.length > 0 ? (
                <img src={clinicDet?.footer} alt="" />
              ) : null
            }
            header={
              <div className="flex-row-ali-cen mv20">
                <div className="w35Per">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
                <div className="w30Per flex-center">
                  <div className="font-bold fs20 blue-color">
                    Medical Record
                  </div>
                </div>
                <div className="w35Per flex1-end">
                  <div className="prescription-doc-header-clinic">
                    <div className="font-bold fs12 blue-color">
                      Business Name:
                    </div>
                    <div className="font-medium blue-color fs12">
                      {clinicDet?.name ?? ""}
                    </div>
                    <div className="font-bold fs12 blue-color mt5">
                      Business Address:
                    </div>
                    <div className="txt-regular fs12 blue-color">
                      {clinicDet?.address ?? ""}
                    </div>
                    {clinicDet?.taxId?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          CLINIC TAX ID:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.taxId ?? ""}
                        </div>
                      </div>
                    ) : null}
                    {clinicDet?.mobile?.length > 0 ? (
                      <div className="flex-row-ali-cen mt5">
                        <div className="font-bold fs12 blue-color">
                          Contact:{" "}
                        </div>
                        <div className="txt-regular fs12 blue-color ml3">
                          {clinicDet?.mobile ?? ""}
                        </div>
                      </div>
                    ) : null}
                  </div>
                  ;
                </div>
              </div>
            }
          >
            <tr>
              <td className="prescription-print-tbody-cell">
                <div className="prescription-print-body-inner">
                  <div className="p5">
                    <div className="mh20 mb20">
                      <div className="flex-row-ali-cen">
                        <div className="w100Per">
                          <div className="flex-row-ali-cen">
                            <Typography className="fs14 blue-color font-bold">
                              Case ID - {lastSummary?.appointment?.caseId}
                            </Typography>
                            <Typography className="light-blue fs14 txt-semi-bold ml10">
                              {lastSummary?.appointment?.serviceType}
                              {lastSummary?.appointment?.serviceType ===
                                "Consultation" &&
                              lastSummary?.appointment?.reason?.length > 0
                                ? ` | ${
                                    Array.isArray(
                                      lastSummary?.appointment?.reason,
                                    )
                                      ? lastSummary?.appointment?.reason?.join(
                                          ", ",
                                        )
                                      : (lastSummary?.appointment?.reason ?? "")
                                  }`
                                : ""}
                            </Typography>
                          </div>
                          <div className="flex-row-ali-cen mt10">
                            {lastSummary?.appointment?.userName?.length > 0 ? (
                              <div className="flex-row-ali-cen">
                                <Typography className="blue-color fs14 txt-semi-bold">
                                  Customer Name:
                                </Typography>
                                <Typography className="black fs14 font-medium ml5">
                                  {lastSummary?.appointment?.userName}
                                </Typography>
                              </div>
                            ) : null}
                            {lastSummary?.appointment?.petName?.length > 0 ? (
                              <div className="flex-row-ali-cen ml10">
                                <Typography className="blue-color fs14 txt-semi-bold">
                                  Pet Name:
                                </Typography>
                                <Typography className="black fs14 font-medium ml5">
                                  {lastSummary?.appointment?.petName}
                                </Typography>
                              </div>
                            ) : null}
                            {lastSummary?.appointment?.petType?.length > 0 ? (
                              <div className="flex-row-ali-cen ml10">
                                <Typography className="blue-color fs14 txt-semi-bold">
                                  Species:
                                </Typography>
                                <Typography className="black fs14 font-medium ml5">
                                  {lastSummary?.appointment?.petType}
                                </Typography>
                              </div>
                            ) : null}
                          </div>
                          <div className="flex-row-ali-cen mt10">
                            {lastSummary?.appointment?.breed?.length > 0 ? (
                              <div className="flex-row-ali-cen">
                                <Typography className="blue-color fs14 txt-semi-bold">
                                  Breed:
                                </Typography>
                                <Typography className="black fs14 font-medium ml5">
                                  {lastSummary?.appointment?.breed}
                                </Typography>
                              </div>
                            ) : null}
                            {genderEnum?.[lastSummary?.appointment?.gender]
                              ?.length > 0 ? (
                              <div className="flex-row-ali-cen ml10">
                                <Typography className="blue-color fs14 txt-semi-bold">
                                  Gender:
                                </Typography>
                                <Typography className="black fs14 font-medium ml5">
                                  {
                                    genderEnum?.[
                                      lastSummary?.appointment?.gender
                                    ]
                                  }
                                </Typography>
                              </div>
                            ) : null}
                            {lastSummary?.appointment?.weight?.length > 0 ? (
                              <div className="flex-row-ali-cen ml10">
                                <Typography className="blue-color fs14 txt-semi-bold">
                                  Weight:
                                </Typography>
                                <Typography className="black fs14 font-medium ml5">
                                  {lastSummary?.appointment?.weight}
                                </Typography>
                              </div>
                            ) : null}
                          </div>
                          <div className="flex-row-ali-cen mt10">
                            <div className="flex-row-ali-cen">
                              <img
                                src={require("../../../../assets/images/png/calen.png")}
                                className="img-wh15"
                              />
                              <Typography className="yellow2 fs14 txt-semi-bold ml5">
                                {moment(
                                  new Date(
                                    lastSummary?.appointment?.appointmentDate,
                                  ),
                                ).format("DD MMM YYYY")}
                              </Typography>
                            </div>
                            <div className="flex-row-ali-cen ml10">
                              <img
                                src={require("../../../../assets/images/png/clock.png")}
                                className="img-wh15"
                              />
                              <Typography className="yellow2 fs14 txt-semi-bold ml5">
                                {lastSummary?.appointment
                                  ?.appointmentStartTime ??
                                  moment(
                                    new Date(
                                      lastSummary?.appointment
                                        ?.appointmentdateTime,
                                    ),
                                  ).format("HH:mm")}
                              </Typography>
                            </div>
                            <div className="flex-row-ali-cen ml10">
                              <img
                                src={require("../../../../assets/images/png/steath.png")}
                                className="img-wh20"
                              />
                              <Typography className="yellow2 fs14 txt-semi-bold ml5">
                                {getRightSaluation(
                                  clinicVets,
                                  lastSummary?.appointment?.doctorId,
                                )}
                                {lastSummary?.appointment?.doctorName}
                              </Typography>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="gry-hor-split mv15" />
                      {lastSummary?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                          lastSummary?.appointment?.appointmentId,
                      )?.conclusion?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Overview
                            </Typography>
                          </div>

                          <Typography className="fs12 txt-regular black">
                            {
                              lastSummary?.clinicalNotes?.find(
                                (cn) =>
                                  cn?.appointmentId ===
                                  lastSummary?.appointment?.appointmentId,
                              )?.conclusion
                            }
                          </Typography>
                        </>
                      ) : null}

                      {lastSummary?.procedures?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Procedures
                            </Typography>
                          </div>

                          <ProceduresView
                            procedures={lastSummary?.procedures}
                          />
                        </>
                      ) : null}
                      {lastSummary?.procedures?.length > 0 &&
                      lastSummary?.procedures
                        ?.flatMap((proc) => proc?.procedureDetails || [])
                        ?.filter(
                          (det) =>
                            det?.type === "Administered" &&
                            det?.status === "true",
                        )?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Administered
                            </Typography>
                          </div>

                          <ProceduresView
                            procedures={lastSummary?.procedures}
                            isAdminister
                          />
                        </>
                      ) : null}
                      {lastSummary?.prevetive?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Preventive
                            </Typography>
                          </div>

                          <PreventiveView
                            preventives={lastSummary?.prevetive}
                          />
                        </>
                      ) : null}
                      {lastSummary?.diagnostics?.filter(
                        (li) =>
                          li?.dueDate ===
                          lastSummary?.appointment?.appointmentDate,
                      )?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Diagnostics
                            </Typography>
                          </div>

                          <DiagnosticsView
                            diagnostics={lastSummary?.diagnostics?.filter(
                              (li) =>
                                li?.dueDate ===
                                lastSummary?.appointment?.appointmentDate,
                            )}
                            showFileAlso
                          />
                        </>
                      ) : null}
                      {(lastSummary?.prescription ?? [])?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Prescription
                            </Typography>
                          </div>

                          <PrescriptionView
                            prescriptions={lastSummary?.prescription ?? []}
                          />
                        </>
                      ) : null}
                      {(lastSummary?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                            lastSummary?.appointment?.appointmentId &&
                          cn?.consolidated,
                      ) ??
                      lastSummary?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                            lastSummary?.appointment?.appointmentId &&
                          !cn?.consolidated,
                      )) ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Soap Notes
                            </Typography>
                          </div>

                          <SoapNoteView
                            apntId={lastSummary?.appointment?.appointmentId}
                            soapNote={
                              lastSummary?.clinicalNotes?.find(
                                (cn) =>
                                  cn?.appointmentId ===
                                    lastSummary?.appointment?.appointmentId &&
                                  cn?.consolidated,
                              ) ??
                              lastSummary?.clinicalNotes?.find(
                                (cn) =>
                                  cn?.appointmentId ===
                                    lastSummary?.appointment?.appointmentId &&
                                  !cn?.consolidated,
                              )
                            }
                          />
                        </>
                      ) : null}
                      {(lastSummary?.inpatientNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                            lastSummary?.appointment?.appointmentId &&
                          cn?.type === "surgery" &&
                          cn?.consolidated,
                      ) ??
                      lastSummary?.inpatientNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                            lastSummary?.appointment?.appointmentId &&
                          cn?.type === "surgery",
                      )) ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Surgery Documentation
                            </Typography>
                          </div>
                          <SoapNoteView
                            apntId={lastSummary?.appointment?.appointmentId}
                            soapNote={
                              lastSummary?.inpatientNotes?.find(
                                (cn) =>
                                  cn?.appointmentId ===
                                    lastSummary?.appointment?.appointmentId &&
                                  cn?.type === "surgery" &&
                                  cn?.consolidated,
                              ) ??
                              lastSummary?.inpatientNotes?.find(
                                (cn) =>
                                  cn?.appointmentId ===
                                    lastSummary?.appointment?.appointmentId &&
                                  cn?.type === "surgery",
                              )
                            }
                            isSurgery
                          />
                        </>
                      ) : null}
                      {lastSummary?.treatmentPlas?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Protocol Forms
                            </Typography>
                          </div>

                          <TreatmentPlanView
                            plans={lastSummary?.treatmentPlas}
                          />
                        </>
                      ) : null}
                      {lastSummary?.forms?.filter((li) => li?.status)?.length >
                      0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Consent Forms
                            </Typography>
                          </div>

                          <FormsView
                            forms={lastSummary?.forms?.filter(
                              (li) => li?.status,
                            )}
                          />
                        </>
                      ) : null}
                      {lastSummary?.vitals?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Vitals
                            </Typography>
                          </div>

                          <VitalsView vitals={lastSummary?.vitals} />
                        </>
                      ) : null}
                      {lastSummary?.bodymaps?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10 cursor">
                            <Typography className="fs14 blue-color font-bold">
                              Body Map
                            </Typography>
                          </div>

                          <BodyMapView bodyMaps={lastSummary?.bodymaps} />
                        </>
                      ) : null}
                      {lastSummary?.files?.length > 0 ? (
                        <>
                          <div className="flex-row-ali-cen mt10">
                            <Typography className="fs14 blue-color font-bold">
                              Files
                            </Typography>
                          </div>

                          <FileView files={lastSummary?.files} />
                        </>
                      ) : null}
                      {lastSummary?.appointment?.notes?.length > 0 ? (
                        <>
                          <Typography className="fs14 blue-color font-bold mt10">
                            Notes
                          </Typography>
                          <Typography
                            className="fs12 txt-regular black"
                            style={{
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                            component="div"
                          >
                            {(lastSummary?.appointment?.notes ?? "")
                              ?.split("\n")
                              ?.map((line, index) => (
                                <div key={index}>{line || "\u00A0"}</div>
                              ))}
                          </Typography>
                        </>
                      ) : null}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </ComponentToPrint>
          <div className="flex-center mt30">
            <div>
              <CustomButton text="Print" smallBtn onClick={handlePrint} />
            </div>
          </div>
          {/* <div className="his-bodr">
            <div className="flex-row-ali-cen mv20">
              <div className="w20Per">
                <div className="pl20">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w60Per flex-center">
                <div className="font-bold fs20 blue-color">Medical Record</div>
              </div>
              <div className="w20Per flex1-end">
                <div className="pr10">
                  <img
                    src={require("../../../../assets/images/png/VetInstantLogo.png")}
                    alt=""
                    className="wh50 blu-back p5"
                  />
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </CustomModal>
    </>
  );
};

export default MedicalHistoryNew;
